export function ensureData(data = '') {
  try {
    data = data.trim()
  }
  catch (ex) {
    data = ''
  }
  return data.length
    ? data
    : 'Keine Angabe'
}



// WEBPACK FOOTER //
// ./src/shared/utils/ensureData.js